export default __webpack_public_path__ + "static/media/landingBackground6.c079a222.png";